import { usePropertiesQuery } from "@/common/api/services/properties";
import { DataCard } from "@/components/shared/DataCard";
import { useQuery } from "@tanstack/react-query";
import { Building2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const PropertiesStats = () => {
  const { t } = useTranslation();
  const propertiesQuery = usePropertiesQuery();

  const { data: properties, isLoading } = useQuery(
    propertiesQuery.allPropertiesQuery({
      page: 0,
      size: 20,
    }),
  );

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="h-24 rounded-lg border border-border bg-card text-card-foreground shadow-sm animate-pulse"
          />
        ))}
      </div>
    );
  }

  const totalProperties = properties?.totalElements || 0;
  const availableProperties =
    properties?.content?.filter((p) => p.status === "available").length || 0;
  const occupiedProperties =
    properties?.content?.filter((p) => p.status === "occupied").length || 0;
  const maintenanceProperties =
    properties?.content?.filter((p) => p.status === "maintenance").length || 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <DataCard title={t("properties.stats.total")} icon={<Building2 />}>
        <div className="text-2xl font-bold">{totalProperties}</div>
      </DataCard>
      <DataCard title={t("properties.stats.available")} icon={<Building2 />}>
        <div className="text-2xl font-bold text-green-600">
          {availableProperties}
        </div>
      </DataCard>
      <DataCard title={t("properties.stats.occupied")} icon={<Building2 />}>
        <div className="text-2xl font-bold text-yellow-600">
          {occupiedProperties}
        </div>
      </DataCard>
      <DataCard title={t("properties.stats.maintenance")} icon={<Building2 />}>
        <div className="text-2xl font-bold text-red-600">
          {maintenanceProperties}
        </div>
      </DataCard>
    </div>
  );
};
